module.exports = __webpack_public_path__ + "static/img/Hamish-Stewart.a467c99.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Hamish-Stewart.jpg
// module id = aSe0
// module chunks = 0